<div class="material-page">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
    
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h1 i18n>How would you like to proceed?</h1>
        <div style="display: flex; gap: 16px; margin-bottom: 16px; flex-wrap: wrap;">
          <span>
            <img [src]="'/select-listing-flow-2.png' | assetUrl" 
                (click)="toSnapAndSell()" 
                style="cursor: pointer;"
                width="133px"
                height="133px"
                angulartics2On="click" 
                angularticsAction="Image Pressed"
                angularticsLabel="select snap&sell"/>
            </span>
          <span style="flex: 1 1 300px;">
            <h2>
              <a (click)="toSnapAndSell()"
                  angulartics2On="click" 
                  angularticsAction="Link Pressed"
                  angularticsLabel="select snap&sell"
                  i18n>Take a few pictures</a>
            </h2>
            <a (click)="toSnapAndSell()" 
                angulartics2On="click" 
                angularticsAction="Link Pressed"
                angularticsLabel="select snap&sell"
                i18n>Just take a few pictures of the item you want to sell. We’ll take care of everything else to make sure you have a killer sales listing. And then just wait for the offers.</a>
          </span>
        </div>
        <div style="display: flex; gap: 16px; flex-wrap: wrap;">
          <span>
            <img [src]="'/select-listing-flow-1.png' | assetUrl" 
                (click)="toItemsList()" 
                style="cursor: pointer;"
                width="133px"
                height="133px"
                angulartics2On="click" 
                angularticsAction="Image Pressed"
                angularticsLabel="select inbox scan"/>
          </span>
          <span style="flex: 1 1 300px;">
            <h2>
              <a (click)="toItemsList()" 
                angulartics2On="click" 
                angularticsAction="Link Pressed"
                angularticsLabel="select inbox scan"
                i18n>Resell an online purchase</a>
            </h2>
            <a (click)="toItemsList()" i18n>If you’re selling something you’ve bought online yourself, we can make it even easier for you. By giving access to your Gmail inbox, our artificial intelligence will identify all your online purchases and make it possible to sell anything with just a click.</a>
          </span>
        </div>
      </div>
      
    </div>
  </div>
</div>